import React from 'react';
import styles from './plansScreen.module.css';
import logo from '../../../assets/images/verticaltv/verticaltv-logo.svg';

export interface Plan {
    id: string;
    price: string;
    originalPrice: string;
    pricePerDay: string;
    duration: string;
    badgeIcon?: string;
    isSelected?: boolean;
}

interface PlansScreenProps {
    plans: Plan[];
    startDate: string;
    endDate: string;
    phoneNumber: string;
    onPlanSelect?: (planId: string) => void;
}

const PlansScreen: React.FC<PlansScreenProps> = ({
    plans,
    startDate,
    endDate,
    phoneNumber,
    onPlanSelect
}) => {
    return (
        <div className={styles.container}>
            {/* Logo */}
           

            {/* Content Section */}
            <div className={styles.contentSection}>
                {/* Title */}
                <h2 className={styles.title}>Buy subscription</h2>

                {/* Plan Cards - Multiple Plans Support */}
                <div className={styles.plansContainer}>
                    {plans.map((plan) => (
                        <div 
                            key={plan.id}
                            className={`${styles.priceCard} ${plan.isSelected ? styles.priceCardSelected : ''}`}
                            onClick={() => onPlanSelect && onPlanSelect(plan.id)}
                        >
                            <div className={styles.priceCardContent}>
                                {/* Price Row */}
                                <div className={styles.priceRow}>
                                    <div className={styles.priceGroup}>
                                        <span className={styles.currentPrice}>{plan.price}</span>
                                        <span className={styles.originalPrice}>{plan.originalPrice}</span>
                                    </div>
                                    <div className={styles.perDayBadge}>
                                        <span className={styles.perDayText}>{plan.pricePerDay}</span>
                                    </div>
                                </div>

                                {/* Duration Row */}
                                <div className={styles.durationRow}>
                                    <span className={styles.durationText}>{plan.duration}</span>
                                    {plan.badgeIcon && (
                                        <div className={styles.badgeIconWrapper}>
                                            <img src={plan.badgeIcon} alt="Badge" className={styles.badgeIcon} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Timeline Section */}
            <div className={styles.timelineSection}>
                <div className={styles.timelineContent}>
                    {/* Vertical Line SVG */}
                    <div className={styles.verticalLine}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="52" viewBox="0 0 7 52" fill="none">
                            <line x1="3.5" y1="9" x2="3.5" y2="43" stroke="url(#paint0_linear_533_7578)" strokeDasharray="2.21 2.21"/>
                            <circle cx="3.5" cy="9.5" r="3.5" fill="white"/>
                            <circle cx="3.5" cy="42.5" r="3.5" fill="#FF4444"/>
                            <defs>
                                <linearGradient id="paint0_linear_533_7578" x1="3" y1="9" x2="2.93458" y2="43.0008" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="white"/>
                                    <stop offset="1" stopColor="#FF4444"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>

                    {/* Dates */}
                    <div className={styles.datesContainer}>
                        <div className={styles.dateRow}>
                            <span className={styles.dateLabel}>Start date</span>
                            <span className={styles.dateValue}>{startDate}</span>
                        </div>
                        <div className={styles.dateRow}>
                            <span className={styles.dateLabel}>End date</span>
                            <span className={styles.dateValue}>{endDate}</span>
                        </div>
                    </div>
                </div>

                {/* Separator */}
                <div className={styles.separator}></div>

                {/* Footer Text */}
                <p className={styles.footerText}>
                    Subscription will be activated on {phoneNumber}
                </p>
            </div>
        </div>
    );
};

export default PlansScreen;
